import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
} from "../actions/AuthActions";

const initialState = {
  auth: {
    email: "",
    name: "",
    idToken: "",
    localId: "",
    expiresIn: "",
    refreshToken: "",
  },
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

export function AuthReducer(state = initialState, action) {
  console.log("snvuiesbves1_3", action);
  // if (action.type === SIGNUP_CONFIRMED_ACTION) {
  //     return {
  //         ...state,
  //         auth: action.payload,
  //         errorMessage: '',
  //         successMessage: 'Signup Successfully Completed',
  //         showLoading: false,
  //     };
  // }
  if (action.type == "[login action] confirmed login") {
    return {
      ...state,
      auth: action.payload,
      errorMessage: "",
      successMessage: "Login Successfully Completed",
      showLoading: false,
    };
  }

  if (action.type == "[Logout action] logout action") {
    return {
      ...state,
      errorMessage: "",
      successMessage: "",
      auth: {
        email: "",
        name: "",
        idToken: "",
        localId: "",
        expiresIn: "",
        refreshToken: "",
      },
    };
  }

  //   if (
  //     action.type === SIGNUP_FAILED_ACTION ||
  //     action.type === LOGIN_FAILED_ACTION
  //   ) {
  //     return {
  //       ...state,
  //       errorMessage: action.payload,
  //       successMessage: "",
  //       showLoading: false,
  //     };
  //   }

  //   if (action.type === LOADING_TOGGLE_ACTION) {
  //     return {
  //       ...state,
  //       showLoading: action.payload,
  //     };
  //   }
  return state;
}
